
<template>
  <div id="loading" :class="{ active: isLoading }" v-if="isLoading === true">
      <RotateSquare5 size="100px" color="#1979cc" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {RotateSquare5} from 'vue-loading-spinner'

export default {
  name: "LoadingOverlay",
  components: {
      RotateSquare5,
  },
  computed: mapGetters(["isLoading"]),
};
</script>

<style lang="scss" src="@/styles/style-loading.scss">
</style>